module.exports = __webpack_public_path__ + "img/code-wrap.bf1db8e2.png";